import { LinkProps } from "react-router-dom";
import { isMenuGroup, MenuLink, MenuLinkGroup, MenuProps } from "./menu";

export class MenuContentFactory {
  private content: Array<MenuLink | MenuLinkGroup> = [];
  private appName: string;

  constructor(appName: string) {
    this.appName = appName;
  }

  addLink(name: string, to?: LinkProps["to"]): void {
    this.content.push({ name, to });
  }

  addGroup(name: string): void {
    this.content.push({ name, links: [] });
  }

  addLinkToGroup(
    groupName: string,
    linkName: string,
    to?: LinkProps["to"]
  ): void {
    const group = this.content.find(
      (item) => isMenuGroup(item) && item.name === groupName
    ) as MenuLinkGroup;

    if (group) {
      group.links.push({ name: linkName, to });
    } else {
      console.warn(`Group with name "${groupName}" not found.`);
    }
  }

  build(): MenuProps {
    return { appName: this.appName, content: this.content };
  }
}
